import apiClient from "../../../../../helpers/api-client";
import { QuizWithProctoringOptions } from "../../../assessments-page/assessments-page-helper";

export enum Status {
	Active = "active",
	Completed = "completed",
	Upcoming = "upcoming",
	ActiveUpcoming = "active-upcoming",
}

export type SessionType = Awaited<ReturnType<typeof apiClient.liveClient.getLiveSessionsWithUsers>>["results"][number];

export type NonNullProctoringOptions = Omit<
	NonNullable<QuizWithProctoringOptions["proctoringOptions"]>,
	"candidateInterviewOptions"
> & {
	candidateInterviewOptions: NonNullable<
		NonNullable<QuizWithProctoringOptions["proctoringOptions"]>["candidateInterviewOptions"]
	>;
};

type NonNullQuizWithProctoringOptions = Omit<QuizWithProctoringOptions, "proctoringOptions"> & {
	proctoringOptions: NonNullProctoringOptions;
};

export type InterviewType = NonNullQuizWithProctoringOptions & {
	liveSession: SessionType;
	status: Status;
};
